'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _buscadorAvanzado = require('./buscador-avanzado.controller');

var _buscadorAvanzado2 = _interopRequireDefault(_buscadorAvanzado);

var _buscadorAvanzado3 = require('./buscador-avanzado.html');

var _buscadorAvanzado4 = _interopRequireDefault(_buscadorAvanzado3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'buscador.componentes.buscador-avanzado';

var ngModule = _angular2.default.module(MODULE_NAME, [_buscadorAvanzado2.default]);

ngModule.component('buscador', {

    controller: 'buscadorController',
    controllerAs: 'app',
    template: _buscadorAvanzado4.default

});

exports.default = MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/componentes/buscador-avanzado/buscador-avanzado.component.js